import React, { useMemo } from 'react'
import styled from 'styled-components'
import { createId } from '../utils/createId'

const Switch = styled<React.FC<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>>>(
  function Switch({ className, children, ...props }) {
    const id = useMemo(() => {
      return props.id || `switch-${createId()}`
    }, [props.id])

    return (
      <span className={className}>
        <input type="checkbox" {...props} id={id} />
        <label htmlFor={id} />
        {!!children && (
          <label htmlFor={id}>
            <b>{children}</b>
          </label>
        )}
      </span>
    )
  }
)`
  display: inline-flex;
  height: 30px;
  vertical-align: -9px;
  flex-direction: row;

  input {
    position: absolute;
    pointer-events: none;
    opacity: 0;
  }

  input + label + label {
    padding-left: 15px;
    flex-grow: 1;
    cursor: pointer;
  }

  input + label {
    position: relative;
    height: 30px;
    width: 50px;
    background: #e6e6e6;
    border-radius: 14px;
    transition: 0.15s background;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    display: inline-block;
  }

  input + label::before {
    content: '';
    position: absolute;
    left: 0;
    width: 46px;
    height: 26px;
    background-color: #e6e6e6;
    border-radius: 13px;
    transform: translate(2px, 2px) scale(1);
    transition: all 0.25s linear;
  }

  input + label::after {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    width: 26px;
    height: 26px;
    background: #fff;
    border-radius: 13px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24);
    transition: transform 0.2s, width 0.2s;
    transform: translate(2px, 2px);
  }

  input + label:active::after {
    width: 28px;
    transform: translate(2px, 2px);
  }

  input:checked + label {
    background-color: #4bd763;

    &::before {
      transform: translate(18px, 2px) scale(0);
    }

    &::after {
      transform: translate(22px, 2px);
    }

    &:active::after {
      transform: translate3d(20px, 2px, 0);
    }
  }
`

export default Switch
